import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RegistryPurchasesRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/registry/project');
  }, [])
  return (
    <div></div>
  )
}

export default RegistryPurchasesRedirect;